import styled from 'styled-components';

import ContentSection from 'components/ContentSection';

export const Wrapper = styled.div`
  margin-top: 0;
`;
export const Blocks = styled(ContentSection)`
  li {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  p {
    a {
      word-break: break-word;
    }
  }
`;
